/**
 * @generated SignedSource<<7a2cb4a1dfc7da765c185090379e3595>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionActionBid_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"OriginalListPrice_item" | "PdpSharedAuctionActionBidLabel_item" | "PdpSharedAuctionBidsDetails_item" | "PriceDisplay_item" | "useAuctionBids_item">;
  readonly " $fragmentType": "PdpSharedAuctionActionBid_item";
};
export type PdpSharedAuctionActionBid_item$key = {
  readonly " $data"?: PdpSharedAuctionActionBid_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionActionBid_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionActionBid_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PriceDisplay_item"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "fetchUser",
          "variableName": "fetchUser"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useAuctionBids_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionBidsDetails_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionActionBidLabel_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OriginalListPrice_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "bca33f1b65c96168908741a1954a6de8";

export default node;
